import React from 'react';
import { Modal, Input, Button } from 'antd';
import { BsPlusLg } from 'react-icons/bs';
import { XcomTable } from './xcom-table';
import { useXcomTab } from './use-xcom-tab';
import styles from '../../styles.module.scss';

const { TextArea } = Input;

type XcomTabProps = {
    dagId: string;
    runId: string;
    taskId: string;
    mapIndex: number;
    refreshKey: number;
};

/*
 * DAG-run-task detail's XCom tab — paginated entries with Add/Edit/Delete CRUD
 */
export function XcomTab({ dagId, runId, taskId, mapIndex, refreshKey }: XcomTabProps) {
    const {
        entries,
        totalEntries,
        offset,
        limit,
        isLoading,
        editingEntry,
        isDialogOpen,
        setIsDialogOpen,
        draftKey,
        setDraftKey,
        draftValue,
        setDraftValue,
        isSubmitting,
        handleOpenAdd,
        handleOpenEdit,
        handleSubmit,
        handleDeleteRequest,
        handleCopyValue,
        handlePrevPage,
        handleNextPage,
    } = useXcomTab(dagId, runId, taskId, mapIndex, refreshKey);

    return (
        <div className={styles.card}>
            <div className={styles.filterRow}>
                <h3 style={{ margin: 0, color: '#fff', fontSize: 14, fontWeight: 700, letterSpacing: 0.25 }}>{`XCom Entries (${totalEntries})`}</h3>
                <div className={styles.filterRowEnd}>
                    <Button type="primary" onClick={handleOpenAdd}>
                        <BsPlusLg style={{ marginRight: 6 }} />
                        Add XCom
                    </Button>
                </div>
            </div>
            <XcomTable entries={entries} isLoading={isLoading} onCopyValue={handleCopyValue} onEdit={handleOpenEdit} onDelete={handleDeleteRequest} />
            {totalEntries > limit && (
                <div className={styles.paginationRow} style={{ justifyContent: 'flex-end' }}>
                    <Button size="small" disabled={offset === 0} onClick={handlePrevPage} style={{ marginRight: 8 }}>
                        Prev
                    </Button>
                    <Button size="small" disabled={offset + limit >= totalEntries} onClick={handleNextPage}>
                        Next
                    </Button>
                </div>
            )}
            {isDialogOpen && (
                <Modal
                    visible
                    className="airflowDashboardRoot"
                    title={editingEntry ? `Edit XCom "${editingEntry.key}"` : 'Add XCom'}
                    onCancel={() => setIsDialogOpen(false)}
                    onOk={handleSubmit}
                    okText={isSubmitting ? 'Saving…' : 'Save'}
                    okButtonProps={{ disabled: isSubmitting || (!editingEntry && !draftKey) }}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                        <div>
                            <div style={{ marginBottom: 4, color: '#666a8d' }}>Key</div>
                            <Input value={draftKey} onChange={(e) => setDraftKey(e.target.value)} disabled={!!editingEntry} />
                        </div>
                        <div>
                            <div style={{ marginBottom: 4, color: '#666a8d' }}>Value</div>
                            <TextArea rows={6} value={draftValue} onChange={(e) => setDraftValue(e.target.value)} style={{ fontFamily: 'monospace' }} />
                        </div>
                    </div>
                </Modal>
            )}
        </div>
    );
}
